import React, { useContext, createContext } from 'react';
/* attributes of PartContext
- name
- partcfg
- reload: () => reloadPartFilters(partName)
- i18n
- user
- dconfig
- domains
- dname
- request
- types
- apiurl
- chunks (from getChunkedUtils)
*/ export const PartContext = /*#__PURE__*/ createContext({});
export const usePartContext = ()=>useContext(PartContext);
